module.exports = __webpack_public_path__ + "clarification.e98bab2e48aaca5f25b3.svg";


//////////////////
// WEBPACK FOOTER
// C:/Aero/Angular/memory-map/src/assets/images/clarification.svg
// module id = ../../../../../src/assets/images/clarification.svg
// module chunks = styles